// SETTINGS CONSTANTS
export const MAX_PRODUCT_VARIANTIONS = 2;

// LOCAL STORAGE KEYS
export const keys = {
	// CONFIGURAÇÕES GERAIS
	ASK_FOR_DELETE_IMAGE: "ASK_FOR_DELETE_IMAGES",
	ADDONS_FORM_RESPONSE: "ADDONS_FORM_RESPONSE_KEY",
	IS_SENSTIVE_CONTENT_HIDDEN: "IS_SENSTIVE_CONTENT_HIDDEN",
	IS_GENERIC_PRODUCTS_HIDDEN: "GENERIC_PRODUCTS_HIDDEN",
	IS_DARK_MODE: "IS_DARK_MODE",
	CAN_ACCESS_APP: "a9713048",
	SHOW_NAMES: "SHOW_NAMES",
	DROP_MODE: "DROP_MODE",
	SEND_RECOVER_PASSWORD_COOLDOWN: "8jbh79",
	PRODUCT_EDIT_ATTRIBUTES_PATH: "PRODUCT_EDIT_ATTRIBUTES_PATH",

	// CONFIGURAÇÕES DE CHAT
	CHAT_UNANSWERED_LIMIT: "CHAT_UNANSWERED_LIMIT",
	CHAT_UNANSWERED_OLD_LIMIT: "CHAT_UNANSWERED_OLD_LIMIT",

	// CONFIGURAÇÕES DE NOTIFICAÇÃO
	IS_AUDIO_DISABLED: "IS_AUDIO_DISABLED",
	IS_TOAST_DISABLED: "IS_TOAST_DISABLED",
} as const;

export type SendRecoverPasswordCooldown = {
	expires_at: string;
	unblocked_at: string;
	attempt: number;
};

export type LocalStorageKeys = (typeof keys)[keyof typeof keys];

export const MINAS_GERAIS_CEP = "37500-003";

export const DEFAULT_SEARCH_KEY = "q" as const;
